(() => {
  if(window.__bwHeaderPortInitialized)return;
  window.__bwHeaderPortInitialized=true;
  const instances = new Map();
  const initialize = () => {
    document.querySelectorAll('[data-bw-port-header]').forEach(header => {
      if (instances.has(header)) return;
      const controller = new AbortController();
      const listen = (node,event,fn) => node?.addEventListener(event,fn,{signal:controller.signal});
      instances.set(header,controller);
      const panels = [
        { button: header.querySelector('[data-bw-port-menu]'), nav: header.querySelector('[data-bw-port-nav]') },
        { button: header.querySelector('[data-bw-port-goals]'), nav: header.querySelector('[data-bw-port-goals-nav]') }
      ].filter(panel => panel.button && panel.nav);
      const close = (restoreFocus = false) => {
        panels.forEach(({ button, nav }) => {
          const wasOpen = !nav.hidden;
          nav.hidden = true;
          button.setAttribute('aria-expanded', 'false');
          if (restoreFocus && wasOpen) button.focus();
        });
      };
      panels.forEach(({ button, nav }) => {
        listen(nav,'click', event => {
          if (event.target.closest('a')) close();
        });
        listen(button,'click', () => {
          const open = nav.hidden;
          close();
          nav.hidden = !open;
          button.setAttribute('aria-expanded', String(open));
          if (open) nav.querySelector('a')?.focus();
        });
      });
      listen(header,'keydown', event => {
        if (event.key === 'Escape' && panels.some(({ nav }) => !nav.hidden)) { event.preventDefault(); close(true); }
      });
      listen(header,'focusout', event => {
        if (!header.contains(event.relatedTarget)) close();
      });
      listen(document,'pointerdown', event => {
        if (header.isConnected && !header.contains(event.target)) close();
      });
      listen(header.querySelector('[data-bw-port-bag-label]'),'click', () => {
        header.querySelector('[data-bw-port-bag] cart-drawer-component > button')?.click();
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload',event=>{for(const [header,controller] of instances)if(event.target.contains(header)){controller.abort();instances.delete(header);}});
})();
